import { render } from "./fzhsSubjectList.vue?vue&type=template&id=46575bab"
import script from "./fzhsSubjectList.vue?vue&type=script&lang=js"
export * from "./fzhsSubjectList.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__